<template>
  <div class="yibiao">
    <div class="left">
      <div class="title">配电室列表</div>
      <el-collapse v-model="activeName" accordion @change="handleChange">
        <el-collapse-item
          v-for="(item, index) in roomList"
          :key="index"
          :name="index"
        >
          <template slot="title">
            <div :title="item.roomName" class="collapse-title">
              <img src="../../assets/images/iconele.png" alt="" />
              <div class="sspan">
                {{ item.roomName }}
              </div>
            </div>
          </template>
          <ul>
            <li
              v-for="(item2, index2) in choiceList"
              :key="'a' + index2"
              :class="
                item.id == choiceObj.id && index2 == choiceObj.index
                  ? 'active'
                  : ''
              "
              @click="choiceClickHandle(item, index2)"
            >
              {{ item2 }}
            </li>
          </ul>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="right" v-if="choiceObj.index != -1">
      <div class="gao">
        <div class="title">{{ choiceList[choiceObj.index] }}配置</div>
        <div class="box">
          <div class="item1" v-if="roomList.length > 0">
            <operation
              :title="choiceList[choiceObj.index]"
              :rootData="roomList[rightIndex]"
              :data="roomList[rightIndex].cabinetTypeList[choiceObj.index]"
              :type="choiceObj.index + 1"
              :isChange="0"
              @setItem="setItem"
              ref="operation"
            ></operation>
          </div>
          <div class="you">
            <i class="iconfont icon-you"></i>
          </div>
          <div class="item2" v-if="roomList.length > 0">
            <operationyibiao
              :title="choiceList[choiceObj.index]"
              :rootData="roomList[rightIndex]"
              :state="state"
              @toState="changeState"
              :data="list"
              :type="choiceObj.index + 1"
              :rightIndexId="rightIndexId"
              @deleteItem="delEquipmentToCabinet"
              @addItem="addEquipmentToCabinet"
              @upItem="updateEquipmentToCabinet"
            ></operationyibiao>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 1高压主进，2低压主进，3高压回路，4低压回路

import {
  Message
} from 'element-ui';
import operation from "./setUp";
import operationyibiao from "./setUpyibiao";
export default {
  components: {
    operation,
    operationyibiao,
  },
  data() {
    return {
      id: "",
      activeName: "",
      roomList: [],
      choiceList: ["高压主进柜", "低压主进柜", "高压回路柜", "低压回路柜"],
      choiceObj: {
        id: "",
        index: -1,
      },
      state: false,
      list: [],
      rightIndex: 0,
      rightIndexId: "",
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.searchRoomCabinetList();
  },
  methods: {
    changeState(val) {
      this.sate = val;
    },
    choiceClickHandle(e, i) {
      this.state = false;
      this.choiceObj = {
        id: e.id,
        index: i,
      };
      this.list = [];
      this.$nextTick(() => {
        this.$refs.operation.activeIndex = -1;
      });
    },
    searchRoomCabinetList(type) {
      this.$http
        .post(
          "bma-distribution-service/equipmentCabinet/searchRoomCabinetList",
          {
            projectId: this.id,
          }
        )
        .then((res) => {
          if (res.code == 200) {
            this.roomList = res.data;
            if (type == 1) {
              if (res.data) {
                this.activeName = 0;
              }
            }
          }
        });
    },
    // 增加表
    addEquipmentToCabinet(Num, equipmentCode) {
      console.log(this.choiceObj, Num);
      this.$http
        .post("bma-distribution-service/equipment/addEquipmentToCabinet", {
          cabinetId: this.rightIndexId,
          equipmentType: this.choiceObj.index + 1,
          localeNumber: Num,
          equipmentCode: this.id + "_" + equipmentCode,
        })
        .then((res) => {
          if (res.code == 200) {
            Message("增加成功");
          }
          this.searchEquipmentByCabinet(this.rightIndexId);
        });
    },
    // 搜索表
    searchEquipmentByCabinet(id) {
      this.$http
        .post("bma-distribution-service/equipment/searchEquipmentByCabinet", {
          cabinetId: id,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.data) {
              let list = [];
              res.data.forEach((item) => {
                if (item.equipmentTypeId == this.choiceObj.index + 1) {
                  list.push(item);
                }
              });
              this.list = list;
            }
          }
        });
    },
    // 删除表
    delEquipmentToCabinet(id) {
      this.$http
        .post("bma-distribution-service/equipment/delEquipmentToCabinet", {
          equipmentId: id,
        })
        .then((res) => {
          if (res.code == 200) {
            Message("删除成功");
            this.searchEquipmentByCabinet(this.rightIndexId);
          }
        });
    },
    // 修改配电柜名称（编号）
    updateEquipmentToCabinet(id, input) {
      this.$http
        .post("bma-distribution-service/equipment/updateEquipmentToCabinet", {
          localeNumber: input,
          equipmentId: id,
        })
        .then((res) => {
          console.log("修改", res);
          if (res.code == 200) {
            Message("修改成功");
            this.searchEquipmentByCabinet(this.rightIndexId);
          }
        });
    },
    handleChange(val) {
      console.log(val);
      this.rightIndex = val;
    },
    setItem(i) {
      console.log(i);
      this.state = false;
      this.rightIndexId = i;
      this.searchEquipmentByCabinet(i);
    },
  },
};
</script>

<style lang="less" scoped>
.yibiao {
  display: flex;
  .left {
    width: 337px;
    height: 1047px;
    background: #f8f8f9;
    box-sizing: border-box;
    overflow-y: scroll;
    .title {
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 2px;
      text-align: left;
      margin-bottom: 15px;
      padding: 0 20px;
      margin-top: 20px;
    }
    /deep/.el-collapse {
      border: none;
      .el-collapse-item__wrap {
        background: rgba(0, 0, 0, 0);
      }
      .el-collapse-item__header {
        border: none;
        background: rgba(0, 0, 0, 0);
        padding: 0 20px;
        .collapse-title {
          display: flex;
          align-items: center;
          img {
            width: 20px;
            margin-right: 8px;
          }
          .sspan {
            width: 220px;
            font-size: 14px;
            text-indent: 0px;
            font-weight: 600;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      ul {
        li {
          height: 33px;
          line-height: 33px;
          font-size: 14px;
          cursor: pointer;
          text-indent: 15px;
          padding: 0 20px;
          &.active {
            font-weight: 600;
            background: rgba(16, 57, 126, 0.1);
          }
        }
      }
    }
  }
  .right {
    margin-left: 15px;
    width: 1285px;
    height: 1077px;
    .gao {
      background: rgba(248, 248, 249, 1);
      height: 1046px;
      padding: 20px;
      box-sizing: border-box;

      .title {
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 2px;
        margin-bottom: 30px;
      }
      .box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item1 {
          width: 373px;
          height: 960px;
          border: 1px solid #e7e7e7;
          padding: 20px;
          padding-top: 0;
          box-sizing: border-box;
        }
        .you {
          color: rgba(33, 105, 225, 1);
          i {
            font-size: 40px;
          }
        }
        .item2 {
          width: 660px;
          height: 960px;
          border: 1px solid #e7e7e7;
          padding: 20px;
          padding-top: 0;
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>